import dayjs from 'dayjs';

import styles from './confirmation-modal-body.module.scss';
import { ImportDocumentWithId } from '@/utils/data-helpers/types';
import { DATE_TIME_PATTERN, FILE_NAME_ALLOWED_LENGTH } from '@/config/common.config';
import { FormattingUtils } from '@/utils/Formatting.utils';

export const ConfirmationModalBody = ({ selectedFile }: { selectedFile: ImportDocumentWithId }) => {
  const fileName =
        FormattingUtils.getValueTrimmed(
          selectedFile?.fileName ?? '',
          FILE_NAME_ALLOWED_LENGTH
        ) ?? 'document';
  const userNameOrUnknown = selectedFile?.uploadedBy ?? 'Unknown User';
  const createdDate = selectedFile?.created
    ? dayjs(selectedFile.created).format(DATE_TIME_PATTERN)
    : 'Unknown date';

  return (
        <div className={styles.content}>
            You are about to delete the usage for {fileName} <br /> uploaded by {userNameOrUnknown} on{' '}
            {createdDate}. <br />
            Please confirm you wish to continue.
        </div>
  );
};
